module.exports = __webpack_public_path__ + "img/pia.98f472d5.png";